/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  no-useless-escape
*/
module.exports = [
  {
    url: '\/api',
    text: 'API',
    options: {
      class: 'm-link-list--link-break-1',
    },
  },
  {
    url: '\/info\/mobile',
    text: 'MOBILE',
    options: {
      class: 'm-link-list--link-break-1',
    },
  },
  {
    text: 'GOOGLE',
    options: {
      class: 'm-link-list--link-break-1',
      sub_menu_class: 'm-marketing-page--google-dropdown-menu-logged-in',
      sub_menu_items: [
        {
          url: '\/gmail',
          text: 'GMAIL',
        },
        {
          url: '\/google-docs-add-on',
          text: 'DOCS',
        },
        {
          url: '\/googledrive',
          text: 'DRIVE',
        },
        {
          url: 'https:\/\/chrome.google.com\/webstore\/detail\/hellosign\/cmblnlmegcfpannmkinlnfpjplgfmbcb',
          text: 'APPS MARKETPLACE',
        },
      ],
    },
  },
  {
    url: '\/info\/pricing',
    text: 'PRICING',
    options: {
      class: 'm-link-list--link-break-1',
    },
  },
  {
    url: '\/info\/tour',
    text: 'BENEFITS',
    options: {
      class: 'm-link-list--link-break-1',
    },
  },
];
